import { render, staticRenderFns } from "./submit-stages.vue?vue&type=template&id=da3fb1c8&scoped=true"
import script from "./submit-stages.vue?vue&type=script&lang=js"
export * from "./submit-stages.vue?vue&type=script&lang=js"
import style0 from "./submit-stages.vue?vue&type=style&index=0&id=da3fb1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3fb1c8",
  null
  
)

export default component.exports